export default "__VITE_ASSET__Dhmmf3fv__"